import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { UntypedFormGroup, FormsModule, ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { Observable, of, forkJoin, EMPTY } from 'rxjs';
import { NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';

import { DnvSearchState, SearchItem, SearchItemType, initialSearchItem, DnvSearchService } from 'dnv-lib';
import { debounceTime, distinctUntilChanged, switchMap, catchError, map } from 'rxjs/operators';

import { LocationService } from 'src/app/services';

@Component({
    selector: 'app-addcase-location',
    templateUrl: './addcase-location.component.html',
    styleUrls: ['./addcase-location.component.scss'],
    standalone: false
})
export class AddcaseLocationComponent implements OnInit {
  // tslint:disable-next-line: no-output-on-prefix
  @Output() onSearchClick = new EventEmitter<SearchItem>();

  @Input() fg: UntypedFormGroup;
  @Input() dnvSearchState: DnvSearchState;

  private readonly defaultIcon = 'far fa-question-circle';
  private selected: SearchItem = initialSearchItem;
  public search: (text$: Observable<string>) => Observable<SearchItem[]>;

  constructor(private locationService: LocationService) {
    this.fg = new UntypedFormGroup({
      addressSearch: new UntypedFormControl('', [Validators.required])
    });
  }

  onSelectItem(event: NgbTypeaheadSelectItemEvent) {
    this.selected = event.item;
    this.onSearchClick.emit(this.selected);
  }

  onKeyDown(evt: any) {
    evt.stopPropagation();
  }

  ngOnInit() {
    this.search = (text$: Observable<string>): Observable<SearchItem[]> => {
      return text$.pipe(
        debounceTime(50),
        distinctUntilChanged(),
        switchMap((name: string) => {
         // const currentSearchUrl = this.dnvSearchState.searchItemsUrl + 'searchitems/' + name;
          if (name.length > 0) {
            return forkJoin({
              searchItems:
                this.locationService.getSearchItems('api/gis/searchapp/' + name)
                  .pipe(
                    catchError((error: HttpErrorResponse): Observable<SearchItem[]> => {
                      return of([]);
                    }),
                  ),
              intersections:
                this.locationService.getSearchItems('api/gis/searchitems/' + name)
                  .pipe(
                    catchError((error: HttpErrorResponse): Observable<SearchItem[]> => {
                      return of([]);
                    }),
                  ),
            });
          } else {
            return EMPTY;
          }
        }),
        map(itemsMap => {
          // Filter out the duplicate entries in the search suggestions that point to the same location
          itemsMap.intersections = itemsMap.intersections.filter((intersection, index, self) =>
            index === self.findIndex((cmpIntersection) =>
              cmpIntersection.name === intersection.name && cmpIntersection.type === intersection.type
            )
          );

          return [...itemsMap.searchItems, ...itemsMap.intersections];
        })
      );
    };
  }


  // Format the autosuggested item into a string for the input control
  formatter = (x: { name: string }) => x.name;

  getClass(type: number): string {
    let result = this.defaultIcon;
    if (this.dnvSearchState.icons) {
      const icon = this.dnvSearchState.icons.find(x => x.id === type);
      if (icon) {
        result = icon.fontAwesome;
      }
    }
    return result;
  }

  onBlur() {
    const locString = this.fg.get('addressSearch').value;
    if (typeof locString === 'string' && '' !== locString) {
      this.fg.get('addressSearch').setValue({ name: locString, id: 0, type: '' });
    }
  }

  /*   jsonStringify(v) {
      const cache = new Set();
      return JSON.stringify(v, function (key, value) {
        if (typeof value === 'object' && value !== null) {
          if (cache.has(value)) {
            // Circular reference found
            try {
              // If this value does not reference a parent it can be deduped
              return JSON.parse(JSON.stringify(value));
            } catch (err) {
              // discard key if value cannot be deduped
              return;
            }
          }
          // Store value in our set
          cache.add(value);
        }
        return value;
      });
    } */
}
